module.exports = __webpack_public_path__ + "static/media/LensScanner.1dadaad6.png";